import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Label, Button, Input } from '@ipc/ipc-components';
import {
  getData,
  getColumns,
  getIsLoading,
} from '../redux/selectors/InternalRepatriationsTransactionsSelectors';
import ListTable from '../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getClickedRowOnTable } from '../../../../../common/tables/reducers/selectors/ListTableSelectors';
import RepatriationsTransactionsHistoryContainer from '../../transactions-history/repatriations/containers/RepatriationsTransactionsHistoryContainer';
import downloadTypes from '../../../../../common/tables/excel/DownloadTypes';
import InternalRepatriationsTransactionsCreate from '../create/containers/InternalRepatriationsTransactionsCreate';
import { TransactionsStyle } from '../../component/Transactions.styles';
import { getUserRole } from '../../../../../common/user/redux/selectors/UserDataSelectors';

class InternalRepatriationsTransactionsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDayCount: 10,
      showCreateTransactionModal: false,
    };
    this.clickApplyButton = this.clickApplyButton.bind(this);
    this.createInternalRepatriation = this.createInternalRepatriation.bind(this);
    this.clickApplyButton();
  }

  componentDidUpdate(prevProps) {
    if (this.props.clickedRow !== prevProps.clickedRow) {
      this.clickApplyButton();
    }
  }

  enterPressed = (e) => {
    const code = e.keyCode || e.which;
    if (code === 13) {
      this.clickApplyButton();
    }
  }

  showCreateFormModal = () => {
    this.setState({
      showCreateTransactionModal: true,
    });
  }

  hideCreateFormModal = () => {
    this.setState({
      showCreateTransactionModal: false,
    });
  }

  handleChange(e) {
    this.setState({
      selectedDayCount: e.target.value,
    });
  }

  clickApplyButton() {
    this.props.tableLoadData(
      {
        tableId: TableDefinitions.INTERNAL_REPATRIATIONS_TRANSACTIONS.id,
      },
      this.props.appContext.appContext,
      {
        impcCode: this.props.clickedRow.impc,
        dayCount: this.state.selectedDayCount,
        transactionCode: 'IRO',
      },
    );
  }

  createInternalRepatriation() {
    this.setState({
      showCreateTransactionModal: true,
    });
  }

  render() {
    const {
      showCreateTransactionModal,
    } = this.state;
    return (
      <TransactionsStyle>
        <Label>
          Show transactions for the last
          <Input
            className="last-day-input"
            value={this.state.selectedDayCount}
            onChange={(e) => this.handleChange(e)}
            onKeyPress={this.enterPressed}
          />
          days
        </Label>
        <Button className="action-buttons" onClick={this.clickApplyButton}>
          Apply
        </Button>
        {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')
          || this.props.userRole.includes('NATIONAL_PALLET_BOX_COORDINATOR')
          || this.props.userRole.includes('NATIONAL_TRAY_COORDINATOR')
          || this.props.userRole.includes('NATIONAL_BAG_COORDINATOR')) && (
          <Button className="action-buttons" onClick={this.createInternalRepatriation}>
            Create Internal Repatriation
          </Button>
        )}
        <ListTable
          listId={TableDefinitions.INTERNAL_REPATRIATIONS_TRANSACTIONS.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
          keyField="id"
          selectCheckbox
          getSubComponentProps={(row) => (
            <div style={{ padding: '20px' }}>
              <RepatriationsTransactionsHistoryContainer
                row={row}
                refreshTransactions={this.clickApplyButton}
              />
            </div>
          )}
          downloadType={downloadTypes.EXCEL}
        />
        {showCreateTransactionModal && (
          <InternalRepatriationsTransactionsCreate
            closeDialog={this.hideCreateFormModal}
            openDialog={this.showCreateFormModal}
            row={this.props.clickedRow}
            refreshTransactions={this.clickApplyButton}
          />
        )}
      </TransactionsStyle>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    isLoading: getIsLoading(state),
    appContext: getAssetType(state),
    clickedRow: getClickedRowOnTable(state),
    userRole: getUserRole(state),
  };
}

InternalRepatriationsTransactionsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  clickedRow: PropTypes.objectOf(PropTypes.shape),
  isLoading: PropTypes.bool,
  userRole: PropTypes.arrayOf(PropTypes.string),
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InternalRepatriationsTransactionsContainer);
